import styled from 'styled-components';

export const ContentWrapper = styled.div`
  font-size: 1.1rem;
  padding: 10px 12px;
  white-space: pre-wrap;
  text-align: left;
`;
